<template>
<div v-if="order">
  <order-history-detail :orderObj="order" />
</div>
</template>

<script>
import OrderHistoryDetail from '@/components/Account/OrderHistoryDetail.vue'
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { findErrorMessage } from '@/services/util.service'

export default {
  components: { OrderHistoryDetail },

  data: () => ({
    order: null,
    error: null
  }),
  computed: {
    ...mapGetters([ 'isLoggedIn' ])
  },
  methods: {
    ...mapMutations([ 'setLoginDialog', 'SET_DIALOG_MESSAGE' ]),
    ...mapActions([ 'showSnack' ])
  },

  mounted() {
    if (this.isLoggedIn) {
      const { orderId } = this.$route.query

      // Allow outside sources to jump straight to a specific order, if it exists
      if (orderId) {
        this.$api.get(`/order/${orderId}`).then(({ data: order }) => {
          if (order) {
            this.order = order
          } else {
            this.SET_DIALOG_MESSAGE({
              title: "Error Occured",
              body: "Bill with order id " + orderId  + " was not found",
              message: 'Please, try another one',
              immutable: true
            })
          }
        }).catch(error => {
          this.SET_DIALOG_MESSAGE({
            title: "Error Occured",
            body: findErrorMessage(error),
            message: 'Please, try another one',
            immutable: true
          })
        })
      }
    } else {
      // http://localhost:8082/owa/snappy/detail/G600/2032/feature?orderId=2032_2021_1108&phoneNumber=2898282949

      this.setLoginDialog(true)

      this.$bus.$on('loggedIn', () => {
        location.reload();
      })
    }
  }
}
</script>

<style scoped>
</style>
